function uploadTeamMemberImage({
  currentEmail = "",
  email = "",
  fileContainer = { files: [] }
}) {
  var formData = new FormData();
  var def = $.Deferred();

  //if there is a new image or the email changed
  if (
    (fileContainer &&
      fileContainer.files[0] &&
      fileContainer.files[0].type.indexOf("image") > -1) ||
    (email && email !== "" && email !== currentEmail)
  ) {
    formData.append("teamMemberImage", fileContainer.files[0]);
    formData.append("email", email);
    formData.append("currentEmail", currentEmail);
    const domainURL = $('body').data('domain');
    $.ajax({
      url: domainURL + "/api/TeamMembers/UploadImage",
      type: "POST",
      data: formData,
      enctype: "multipart/form-data",
      processData: false, // tell jQuery not to process the data
      contentType: false // tell jQuery not to set contentType
    })
      .done(function (data) {
        def.resolve(data);
      })
      .fail(function (data) {
        def.reject(data);
      });
  } else {
    def.resolve();
  }
  return def;
}

export default uploadTeamMemberImage;
